import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="mx-auto flex min-h-[80vh] max-w-md flex-col justify-center px-6 py-16">
      <div className="border border-[#27272A] bg-[#141415]">
        <div className="flex items-center gap-3 border-b border-[#27272A] p-6">
          <Lock className="h-5 w-5 text-[#FFB800]" />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FFB800]">Dealer Access</div>
            <h1 className="mt-1 font-display text-2xl font-bold uppercase">Admin Login</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4 p-6">
          <div>
            <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border border-[#27272A] bg-[#0a0a0b] p-3 font-mono text-sm text-white focus:border-[#FFB800] focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border border-[#27272A] bg-[#0a0a0b] p-3 font-mono text-sm text-white focus:border-[#FFB800] focus:outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full bg-[#FFB800] px-6 py-4 font-display text-sm font-bold uppercase tracking-widest text-black hover:bg-[#E5A600] disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
